import React from 'react';
import PropTypes from 'prop-types';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { HelpPopup } from '@bingads-webui-react/help-popup';
import { SparkleIcon } from '@bingads-webui-campaign-react/sparkle-icon';
import { getPanelHeaderStyles } from './style/panel-header-style';

export const PanelHeader = ({ i18n }) => {
  const classes = useDefaultStyles(getPanelHeaderStyles);

  return (
    <div className={classes.root}>
      <div className={classes.image}>
        <SparkleIcon />
      </div>
      <div>
        {i18n.getString(_TL_('Explore keywords'))}
        <HelpPopup
          topic="pop_BA_SearchRevamp_ExploreKeywords"
          aria-label={i18n.getString(_TL_('Click to learn more about explore keywords'))}
        />
      </div>
    </div>
  );
};

PanelHeader.propTypes = {
  i18n: PropTypes.shape({
    getString: PropTypes.func.isRequired,
  }).isRequired,
};
